import React from 'react';
import { getBlockComponent } from './registry';
import { BlockComponent } from '@/types/blocks';

interface BlockRendererProps {
  blockType: string;
  data: any;
  blockRenderKey: string;
}

export const BlockRenderer: React.FC<BlockRendererProps> = ({ 
  blockType, 
  data, 
  blockRenderKey 
}) => {
  const finalRenderKey = blockRenderKey || 'default';
  const Component: BlockComponent = getBlockComponent(finalRenderKey);

  return (
    <div data-cms-block={blockType} data-cms-render-key={finalRenderKey}>
      <Component data={data} />
    </div>
  );
};